import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    ordenProveedorFormaPago: null,

    formaPagoId: 0,
    formaPago: null,
    formaPagoNombre: null,
    porcentaje: 0,
    condiciones: '',
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDEN_PROVEEDOR_FORMA_PAGO' (state) {
        state.ordenProveedorFormaPago = {};

        state.formaPagoId = 0;
        state.formaPago = null;
        state.formaPagoNombre = null,
        state.porcentaje = 0;
        state.condiciones = '';
    },
    'SET_ORDEN_PROVEEDOR_FORMA_PAGO' (state, ordenProveedorFormaPago) {
        state.ordenProveedorFormaPago = ordenProveedorFormaPago;

        state.formaPagoId = ordenProveedorFormaPago.formaPago ? ordenProveedorFormaPago.formaPago.id : 0;
        state.formaPago = ordenProveedorFormaPago.formaPago;
        state.formaPagoNombre = ordenProveedorFormaPago.formaPago ? ordenProveedorFormaPago.formaPago.nombre.trim() : null;
        state.porcentaje = ordenProveedorFormaPago.porcentaje;
        state.condiciones = ordenProveedorFormaPago.condiciones;
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.formaPagoId = formaPago ? formaPago.id : 0;
        state.formaPago = formaPago;
        state.formaPagoNombre = formaPago ? formaPago.nombre.trim() : null;
    },

    'ORDEN_PROVEEDOR_FORMA_PAGO' (state, ordenProveedorFormaPago) {
        state.ordenProveedorFormaPago = ordenProveedorFormaPago;
    }
};

const getters = {
    getField,

    ordenProveedorFormaPago (state) {
        return state.ordenProveedorFormaPago;
    },
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDEN_PROVEEDOR_FORMA_PAGO');

            let setFormaPago = false;
            if (params) {
                if (params.ordenProveedorFormaPago) {
                    setFormaPago = true;
                }
            }

            if (setFormaPago) {
                commit('SET_ORDEN_PROVEEDOR_FORMA_PAGO', params.ordenProveedorFormaPago);
                resolve();
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let item = {
                formaPagoId: state.formaPagoId, 
                formaPago: state.formaPago,
                porcentaje: parseFloat(state.porcentaje),
                condiciones: state.condiciones.trim().toUpperCase(),
            }
            commit('ORDEN_PROVEEDOR_FORMA_PAGO', item);
            resolve()
        }, error => {
            reject(error);
        })
    },
    setFormaPago: ( {commit }, formaPago) => {
        return new Promise((resolve, reject) => {
            commit('SET_FORMA_PAGO', formaPago);
            resolve();
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}